import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  updateBid,
  updateInterview,
  updateProposal,
} from "../../../../redux/actions";
import { Modal } from "antd";

const RejectionModal = (props) => {
  const dispatch = useDispatch();
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectReason, setRejectReason] = useState(false);
  const [rejectReasonId, setRejectReasonid] = useState();
  const [interviewId, setInterviewId] = useState(false);



  useEffect(() => {
    setRejectModalVisible(props.open);
    setInterviewId(props?.interviewId)
  }, [props]);

  function rejectModalClose(params) {
    setRejectModalVisible(false);
    props.close(false);
  }

  return (
    <>
      <Modal
        title={props.title}
        onCancel={rejectModalClose}
        visible={rejectModalVisible}
        footer={null}
      >
        <div>{props.text}</div>
        <div
          className="reject-modal-div"
          data-id="Accepted another candidate"
          style={{
            background:
              rejectReason == "Accepted another candidate" && "#e4ffec",
          }}
          onClick={(e) => {
            setRejectReason(e.target.getAttribute("data-id"));
            setRejectReasonid(1);
          }}
        >
          Accepted another candidate
        </div>
        <div
          className="reject-modal-div"
          data-id="Not Interested in the candidate"
          style={{
            background:
              rejectReason == "Not Interested in the candidate" && "#e4ffec",
          }}
          onClick={(e) => {
            setRejectReason(e.target.getAttribute("data-id"));
            setRejectReasonid(2);
          }}
        >
          Not interested in the candidate
        </div>
        <div
          className="reject-modal-div"
          data-id="Asking Payrate is too high"
          style={{
            background:
              rejectReason == "Asking Payrate is too high" && "#e4ffec",
          }}
          onClick={(e) => {
            setRejectReason(e.target.getAttribute("data-id"));
            setRejectReasonid(4);
          }}
        >
          Asking payrate is too high
        </div>

        <button
          className="rejectModalBtn"
          onClick={() => {
            if (props.title == "Cancel this Interview?") {
                dispatch(
                  updateInterview({
                    InterviewId: interviewId,
                    InterviewStatus: "Rejected",
                    ReasonId: rejectReasonId,
                    type: "emp",
                    loading: "Cancel-parent",
                    reschedule: true,
                    DeclineReason: rejectReason,
                    isDeclined: true
                  })
                );

                setRejectModalVisible(false);
                props.close(false);
            } else {
              if (props.bidData?.SkillListings) {
                dispatch(
                  updateBid({
                    id: props.bid,
                    BidStatusName: "Declined",
                    SkillListingId: props.bidData?.SkillListings.SkillListingId,
                    DeclineReasonId: rejectReasonId,
                  })
                );

                setRejectModalVisible(false);
                props.close(false);
              } else {
                dispatch(
                  updateProposal({
                    id: props.id,
                    status: "Declined",
                    DeclineReasonId: rejectReasonId,
                  })
                  );
                  setRejectModalVisible(false);
                  props.close(false);
              }
            }
          }}
        >
          Submit Reason
        </button>
      </Modal>
    </>
  );
};

export default RejectionModal;
